import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { SelectColumnFilter } from "components/ClpTable/ClpTableFilterTypes"
import { TableLoadingStateEnum } from "components/ClpTable/tableProps.interface"
import theme from "css/theme/light"
import { apiEndpoints } from "generated/apiEndpoints"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import Moment from "react-moment"

const DataCell = ({ item }: any) => {
  return (
    <Box display="flex" justifyContent={useMediaQuery(theme.breakpoints.up("xl")) ? "flex-start" : "flex-end"}>
      <Typography variant="bodySmall" color={theme.palette.grey[600]} marginRight={1}>
        {item[0]}:
      </Typography>
      {item[1]}
    </Box>
  )
}
const SystemEvents = () => {
  const { t } = useTranslation()
  const [systemEventsResult, listSystemEvents] = useApi() as [IApiResult, IApiFunc]

  useEffect(() => {
    listSystemEvents.get(apiEndpoints.systemadmindeviceregistry.listsystemevents)

    return () => {
      listSystemEvents.leave()
    }
  }, [listSystemEvents])

  const columns = [
    {
      accessorKey: "eventTime",
      header: t("sysadmin.time", "Time"),
      cell: ({ cell }: any) => {
        return (
          <Moment utc local format="YYYY-MM-DD HH:mm">
            {cell.row.original.eventTime}
          </Moment>
        )
      }
    },
    {
      accessorKey: "user.name",
      header: t("global.user", "Users"),
      meta: {
        mainFilter: true,
        filter: SelectColumnFilter
      }
    },
    {
      accessorKey: "systemEventType",
      header: t("global.type", "Type"),
      meta: {
        mainFilter: true,
        filter: SelectColumnFilter
      }
    },

    {
      accessorKey: "serializedDictionaryValues",
      header: t("global.data", "Data"),
      cell: ({ cell }: any) => {
        return Object.entries(cell.row.original.dictionaryValues).map(
          (item, key) => item && <DataCell item={item} />
        )
      }
    }
  ]

  return (
    <div>
      <Container>
        <Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Box order={2} flexGrow={2}>
              <Grid item>
                <Typography variant="h1">{t("global.features.title.systemevents", "System events")}</Typography>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
      <Box>
        <ClpTable
          rows={systemEventsResult.status === 2 && systemEventsResult.data}
          loadingState={systemEventsResult.status as TableLoadingStateEnum}
          columns={columns}
        />
      </Box>
    </div>
  )
}
export default SystemEvents
